
import { useEffect, useState } from "react";
import { cloneDeep, random } from "lodash";
import { useSearchParams } from "react-router-dom";
import { callAPIForQuery, PROD_URL, sendWhatsapp } from "../../utilities/service";
import { Loader } from "../common/Loader";
import { useCustomContext } from "../../state/CustomContext";
import moment from "moment";
import { downloadFile } from "../../utilities/helper";
import { faDownload, faEye, faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DOCTOR_ROLE_ID, START_HIS, TOAST } from "../../utilities/constant";
import { Toggle } from "../common/Toggle";
import { HIS } from "../HIS";
import Modal from "../common/Modal";
import toast, { Toaster } from "react-hot-toast";
import { ToastPanel } from "../common/ToastPanel";
export const ParmedicalInfo = () => {
    const [doctor, setDoctor] = useState([]);
    const [inputList, setInputList] = useState<any>({
        "temperature": {
            display: "Temp",
            control: "number"
        },
        "pulse": {
            display: "Pulse",
            control: "number"
        },
        "resp": {
            display: "Resp",
            control: "number"
        },
        "bp": {
            display: "BP",
            control: "number"
        },
        "spo2": {
            display: "SPO2",
            control: "number"
        },
        "gcs": {
            display: "GCS",
            control: "number"
        },
        "pain_score": {
            display: "Pain Score",
            control: "number"
        },
        // "smoking": {
        //     display: "Smoking",
        //     control: "dropdown",
        //     data: [
        //         {
        //             name: "--Select--",
        //             value: ""
        //         },
        //         {
        //             name: "Yes",
        //             value: "yes"
        //         },
        //         {
        //             name: "No",
        //             value: "no"
        //         }
        //     ]
        // },
        // "drinking": {
        //     display: "Drinking",
        //     control: "dropdown",
        //     data: [
        //         {
        //             name: "--Select--",
        //             value: ""
        //         },
        //         {
        //             name: "Yes",
        //             value: "yes"
        //         },
        //         {
        //             name: "No",
        //             value: "no"
        //         }
        //     ]
        // },
        "medical_short_history_notes": {
            display: "Medical Short History Notes",
            control: "textarea"
        },
        "upload_medical_history": {
            display: "Upload Medical History",
            control: "file"
        },
    });
    const context = useCustomContext();
    const { state } = context;

    const [showPatientInfo] = useState<boolean>(true)
    const [viewMedicalInfo, setViewMedicalInfo] = useState<boolean>(false)
    const [setMedicalInfo, setSetMedicalInfo] = useState<boolean>(false)
    const [HISShow, setHISShow] = useState<boolean>(false)


    const [appointment, setAppointment] = useState<any>([])
    const [paramedicalInfo, setParamedicalInfo] = useState<any>([])
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState<any>({});

    const [searchParams] = useSearchParams(); // Get query params
    let appointment_id = searchParams.get("appointment_id");
    if (appointment_id) {
        appointment_id = window.atob(appointment_id)
    }
    useEffect(() => {
        refreshComponent();
        loadDoctor();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    const updateInputInfo = (key: string, value: string) => {

        setInput((prevState: any) => {
            const inputCopy: any = cloneDeep(prevState);
            inputCopy[key] = value;
            return inputCopy;
        });

    }
    const refreshComponent = () => {
        setInput({})
        getPatient();
    }
    const getPatient = async () => {
        let xmlString = '<profile>';
        xmlString += `<id>${appointment_id}</id>`;
        xmlString += '</profile>'
        setLoading(true)
        const result = await callAPIForQuery({ input: xmlString, type: 'GetAppointmentsByDate' }, 'post')
        setLoading(false)
        if (!result.error) {
            setAppointment(result[0][0]);
            setParamedicalInfo(result[2])
        }
    }
    const handleFileUpload = (input: any, key: string) => {
        if (input.files && input.files[0]) {
            const file = input.files[0];
            const reader = new FileReader();

            reader.onload = function (e: any) {
                const base64String = e.target.result.split(',')[1]; // Extract Base64
                const fileExtension = file.name.split('.').pop(); // Get file extension
                updateInputInfo(key, `${fileExtension}|||${base64String}`);
                // console.log("Base64 String:", base64String);
                // console.log("File Extension:", fileExtension);
            };

            reader.readAsDataURL(file);
        }
    }

    const remove = (key: string) => {
        const inputListCopy = cloneDeep(inputList);
        delete inputListCopy[key];
        setInputList(inputListCopy)
    }
    const addMoreFileUpload = (key: string) => {

        const inputListCopy = cloneDeep(inputList);
        for (let i = 1; i <= 5; i++) {
            const checkField = `${key}_${i}`
            if (!inputListCopy[checkField]) {
                inputListCopy[checkField] = {
                    display: `${inputList[key].display}_${i}`,
                    control: "file",
                    addedDynamically: true
                }
                break;
            }
        }
        setInputList(inputListCopy)

    }
    const startHIS = async () => {
        let inputCopy = cloneDeep(input);
        if (!inputCopy.his_doctor_id) {
            alert("Please select the doctor")
        } else {
            inputCopy = { ...inputCopy, [START_HIS]: moment().format("DD MMM YYYY HH:MM") };
            setInput(inputCopy);

            setLoading(true)
            await saveInput(inputCopy);
            await sendSMSToDoctor(inputCopy.his_doctor_mobile_no, inputCopy.his_doctor_name, inputCopy.his_doctor_login_username)
            setLoading(false)
            setHISShow(false);
        }
    }
    const sendSMSToDoctor = async (mobile_no: string, doctorName: string, loginUserName: string) => {
        const token = random(true);
        //https://mgmvc1.mgmhealthcare.in%3Fid%3D123%26name%3DJohn
        const redirectUrl = `${PROD_URL}%3Fusername%3D${loginUserName}%26token%3D${token}%26roleid%3D${DOCTOR_ROLE_ID}`;
        await createAutoLogin(loginUserName, token.toString());
        const message = `Dear+${doctorName}%2C+The+patient+is+seeking+your+clinical+guidance+and+would+like+to+connect+with+you.+Kindly+join+the+consultation+using+the+following+URL%3A${redirectUrl}.+%E2%80%93+Team+MGM`
        return sendWhatsapp({
            "phoneNo": mobile_no,
            message
            // "message": "Dear+" + doctorName + "%2C+The+patient+is+seeking+your+clinical+guidance+and+would+like+to+connect+with+you.+Kindly+join+the+consultation+using+the+following+URL%3A" + redirectUrl + ".+%E2%80%93+Team+MGM"
        })
    }
    const onSave = async () => {
        await saveInput(input)
    }
    const createAutoLogin = async (username: string, token: string) => {
        const payload = `{
                "username": "${username}",
                "token": "${token}",
                "default_url": "${window.location.href}",
                "created_by": "${state.user_id}",
                "role_id":"${DOCTOR_ROLE_ID}"
                }`;
        setLoading(true)
        const result = await callAPIForQuery({ input: payload, type: 'insert_auto_login' }, 'post')
        setLoading(false)
        if (result.error) {
            alert("Error in creating the login session for the doctor")
            // alert("Saved Successfully");
            // refreshComponent();
        }
    }
    const saveInput = async (inputList: any) => {
        let steps: any = [];
        Object.keys(inputList).forEach((val: any) => {
            steps.push({ "field": val, "value": inputList[val] })
        })
        const payload = `[  {
            "appointment_id": ${appointment.id},
            "created_by": "${state.user_id}",
            "user_selection" : ${JSON.stringify(steps)}
        }]`;
        setLoading(true)
        const result = await callAPIForQuery({ input: payload, type: 'insert_paramedical_values' }, 'post')
        setLoading(false)
        if (!result.error) {
            if (inputList.his_doctor_id) {
                toast.success(<ToastPanel message={`Successfully assigned the doctor and sent the notification in whatsapp`} />, TOAST)
            } else {
                toast.success(<ToastPanel message={`Successfully updated the data`} />, TOAST)
            }
            // alert("Saved Successfully");
            refreshComponent();
        }
    }
    const loadDoctor = async () => {
        const procedure = 'get_doctor';
        setLoading(true)
        const result = await callAPIForQuery({ input: '{}', type: procedure }, 'post')
        setLoading(false)
        if (!result.error) {
            setDoctor(result[0])
        } else {
            setDoctor([])
        }
    }
    if (loading) {
        return <Loader />
    }
    const isHISStarted = paramedicalInfo.some((opt: any) => opt.field === START_HIS)
    return <div>
        <Toaster position="bottom-right" />
        {/* <Toggle status={showPatientInfo} displayText="Patient Info" onClick={() => setShowPatientInfo(!showPatientInfo)} />
        <hr /> */}
        {showPatientInfo && (<>
            {appointment?.id && <div className="appointment-grid">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Phone No</th>
                            <th>Gender</th>
                            <th>Age</th>
                            {/* <th>Vechile No</th> */}
                            <th>Created Date</th>
                            <th>Medical Info</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr >
                            <td>{appointment.id}</td>
                            <td>{appointment.first_name}</td>
                            <td>{appointment.last_name}</td>
                            <td>{appointment.phone_no}</td>
                            <td>{appointment.gender_name}</td>
                            <td>{appointment.age}</td>
                            {/* <td> {appointment.ambulance_vechile_name}</td> */}
                            <td>{moment(appointment.created_date).format("DD MMM YYYY HH:MM")}</td>
                            <td>
                                <div className="action-set icons">
                                    <div onClick={() => {
                                        debugger;
                                        setSetMedicalInfo(!setMedicalInfo)
                                    }}>
                                        <FontAwesomeIcon icon={faPencil} />
                                    </div>
                                    <div onClick={() => setViewMedicalInfo(!viewMedicalInfo)}>
                                        <FontAwesomeIcon icon={faEye} />
                                    </div>
                                </div>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>}
        </>)}
        <Modal width={"80vw"} isOpen={viewMedicalInfo} onClose={() => setViewMedicalInfo(!viewMedicalInfo)}>
            <Toggle status={true} displayText="View Medical Info" onClick={() => { }} />
            <hr />
            <div className="row">
                <div className='col-lg-2'>
                    {isHISStarted && <input type="button" value="Re send SMS" onClick={async () => {
                        const phoneNo = paramedicalInfo.find((info: any) => info.field === "his_doctor_mobile_no")?.value
                        const doctorName = paramedicalInfo.find((info: any) => info.field === "his_doctor_name")?.value
                        const login_username = paramedicalInfo.find((info: any) => info.field === "his_doctor_login_username")?.value

                        const result = await sendSMSToDoctor(phoneNo, doctorName, login_username);
                        if (result.response.status === "error") {
                            alert(`Error in sending the whatsapp message to doctor ${doctorName} on his/her phone number ${phoneNo}. Please contact your adminstrator`)
                        } else {
                            alert(`Successfully sent the message to doctor ${doctorName} on his/her phone number ${phoneNo}`)
                        }
                    }} />}
                </div>
            </div>
            {!paramedicalInfo?.length && (<div>No records found.</div>)}
            {paramedicalInfo?.length > 0 && <div className="appointment-grid">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Value</th>
                            <th>Created Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            paramedicalInfo.map(((status: any) => {
                                return (<tr key={status.id}>
                                    <td style={{ textTransform: "uppercase" }}>{status.field}</td>
                                    <td>
                                        {/* {!status.field.includes("upload") ? status.value : <a className="download-file"
                                        onClick={() => {
                                            downloadFile(status.field, status.value)
                                        }} >Download File</a>} */}
                                        {!status.field.includes("upload") ? status.value : <FontAwesomeIcon icon={faDownload} style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                downloadFile(status.field, status.value)
                                            }} />}


                                    </td>
                                    <td>{moment(status.value_created_date).format("DD MMM YYYY HH:MM")}</td>
                                </tr>)
                            }))
                        }
                    </tbody>
                </table>
            </div>}

        </Modal>

        <Modal width={"80vw"} isOpen={setMedicalInfo} onClose={() => {
            debugger;
            setSetMedicalInfo(!setMedicalInfo)
        }}  >
            <Toggle status={setMedicalInfo} displayText="Set Medical Info" onClick={() => { }} />
            <hr />

            <div className="row">
                {
                    Object.keys(inputList).map((key: string) => {
                        return (<div className="col-lg-3 form-option" key={key}>
                            <div className="field-title"> {inputList[key].display} </div>
                            {inputList[key].control === "textbox" && (<input className="form-control"
                                value={input[key] || ''}
                                onChange={(event: any) => {
                                    debugger;
                                    updateInputInfo(key, event.target.value)
                                }} />)}
                            {inputList[key].control === "number" && (<input className="form-control" type="number"
                                value={Number(input[key]) || 0}
                                onChange={(event: any) => {

                                    if (isNaN(event.target.value)) {
                                        updateInputInfo(key, '0')
                                    } else {
                                        updateInputInfo(key, event.target.value.toString())
                                    }

                                }} />)}
                            {inputList[key].control === "textarea" && (<textarea className="form-control"
                                value={input[key] || ''}
                                rows={1}
                                cols={25}
                                onChange={(event: any) => {
                                    updateInputInfo(key, event.target.value)
                                }} />)}
                            {inputList[key].control === "file" && (<>
                                <input className="form-control" type='file'

                                    onChange={(event: any) => { handleFileUpload(event.currentTarget, key) }} />
                                <div className="action-set no-left-padding no-top-padding">
                                    <div className="link-text" onClick={() => { downloadFile(key, input[key]) }}>View File</div>
                                    {inputList[key].addedDynamically && (<div className="link-text" onClick={() => { remove(key) }}>Remove</div>)}

                                    {!inputList[key].addedDynamically && (<div className="link-text" onClick={() => { addMoreFileUpload(key) }}>Add more File</div>)}

                                </div>
                            </>
                            )}
                            {inputList[key].control === "dropdown" && (
                                <select className="form-control" onChange={(event: any) => {
                                    updateInputInfo(key, event.target.value)
                                }}>
                                    {
                                        inputList[key].data.map((record: any) => {
                                            return (<option value={record.value} key={record.value}>
                                                {record.name}
                                            </option>)
                                        })
                                    }
                                </select>
                            )}
                        </div>)
                    })
                }
            </div>
            <div className="action-set no-top-padding" >
                <input type="button" value="Save" onClick={onSave} />
            </div>
        </Modal>
        <Modal width={"80vw"} isOpen={HISShow} onClose={() => setHISShow(!HISShow)}  >
            <Toggle status={setMedicalInfo} displayText="Start HIS" onClick={() => setHISShow(!HISShow)} />
            <hr />
            <div className="row">
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Doctor</label>
                    <select className="form-control" onChange={(event: any) => {
                        const selectedId = event.target.value;
                        const selectedDoctor: any = doctor.find((d: any) => d.id.toString() === selectedId);
                        updateInputInfo("his_doctor_id", selectedDoctor?.id || '')
                        updateInputInfo("his_doctor_name", selectedDoctor?.name || '')
                        updateInputInfo("his_doctor_mobile_no", selectedDoctor?.mobile_no || '')
                        updateInputInfo("his_doctor_login_username", selectedDoctor?.login_username || '')
                    }}>

                        <option value="-1">--Select Role--</option>
                        {
                            doctor.map((doctor: any) => {
                                return <option key={doctor.id} value={doctor.id}>{doctor.name}</option>
                            })
                        }
                    </select>
                </div>
                {input.his_doctor_mobile_no && (<div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Mobile No</label>
                    <input type="text" className="form-control" disabled={true} value={input.his_doctor_mobile_no} />
                </div>)}
                {input.his_doctor_login_username && (<div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Login Username</label>
                    <input type="text" className="form-control" disabled={true} value={input.his_doctor_login_username} />
                </div>)}
            </div>
            <div className="action-set no-top-padding" >
                <input type="button" value="Start HIS" onClick={startHIS} />
            </div>
        </Modal>
        {isHISStarted && (<div>
            <HIS role_id={state.role_id} user_name={state.display_name} user_id={state.user_id} appointment_id={appointment_id} vechile_no={appointment.ambulance_vechile_name} sectionCount={appointment.ambulance_vechile_no_of_sections} />
        </div>)}
        <div className="action-set no-left-padding" >
            {!isHISStarted && (<input type="button" value="Save" onClick={onSave} />)}
            {!isHISStarted && <input type="button" value="Start HIS" onClick={() => {
                setInput({});
                setHISShow(!HISShow);
            }} />}
        </div>
    </div>
}